import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { FilterParams, SortDirection } from '@synergy/models';

import { NewsPostDto } from '../models/dto/news-post-dto';

export class NewsApi {
    constructor(protected baseUrl: string) {}

    public getNews = (
        searchParams: URLSearchParams = new URLSearchParams()
    ): Promise<ApiResult<PaginatedResponse<NewsPostDto>>> => {
        searchParams.get(FilterParams.PageSize) || searchParams.set(FilterParams.PageSize, '15');
        searchParams.set(FilterParams.SortBy, 'publishAt');
        searchParams.set(FilterParams.SortDirection, SortDirection.Descending);
        return safeRequest(
            () => request.get(`${this.baseUrl}/news-posts`, { params: searchParams }),
            response => response.data
        );
    };

    public getNewsDetails = (id: number): Promise<ApiResult<NewsPostDto>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/news-posts/${id}`),
            response => response.data
        );
    };
}
